import { Icon } from "components/Icon";
import { HeaderProps, IButton } from "data/header";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { headerAndBottomVisibleState } from "recoil/atoms";
import styles from "./style.module.css";

const ACCESS_FIRST_PAGE = window.location.href;

export default function Header({
  left,
  backHandler,
  right,
  title,
  isVisible,
  url,
  cloaseModal,
  propsNavigate,
}: HeaderProps) {
  console.log("isVisible", isVisible);

  return (
    <>
      {isVisible ? (
        <header className={styles.header}>
          <div className={styles.left}>
            <LeftContent
              left={left}
              url={url}
              backHandler={backHandler}
              cloaseModal={cloaseModal}
              propsNavigate={propsNavigate}
            />
          </div>
          <div className={styles.title}>{title}</div>
          <div className={styles.right}>
            <RightContent right={right} />
          </div>
        </header>
      ) : (
        <></>
      )}
    </>
  );
}

function LeftContent({
  left,
  backHandler,
  url,
  cloaseModal,
  propsNavigate,
}: {
  left?: string | JSX.Element;
  backHandler?: () => boolean;
  url?: string;
  cloaseModal?: () => void;
  propsNavigate?: () => void;
}) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const headerAndBottomVisible = useRecoilValue(headerAndBottomVisibleState);
  const [backCount, setBackCount] = useState(0);

  if (left) {
    if (left === "back") {
      return (
        // back은 웹뷰를 사용할때 사용할 것
        <Icon
          name="back"
          onClick={() => {
            if (!!backHandler) {
              const isBackable = backHandler?.();
              if (isBackable) {
                return;
              }
            }
            if (
              ACCESS_FIRST_PAGE ===
                window.location.href.replace("&test=1", "") ||
              history.length === 1 ||
              pathname === "/"
            ) {
              window.close();
            } else {
              if (
                headerAndBottomVisible.OS === "android" &&
                history.length - backCount <= 1
              ) {
                window.close();
              } else {
                setBackCount(backCount + 1);
                navigate(-1);
              }
            }
          }}
        />
      );
    } else {
      return <>{left}</>;
    }
  }
  if (url) {
    return (
      <Icon
        name="back"
        onClick={() => {
          if (cloaseModal) {
            cloaseModal();
          }
          if (url === "-1") {
            navigate(-1);
          } else {
            navigate(url);
          }
        }}
      />
    );
  }
  if (propsNavigate) {
    return <Icon name="back" onClick={propsNavigate} />;
  }
  return <></>;
}

function RightContent({ right }: { right?: IButton }) {
  if (typeof right === "object") {
    const button = right as IButton;
    if (button.icon) {
      return (
        <div
          style={{ cursor: "pointer", color: button.color }}
          onClick={button.onClick}
        >
          <img src={button.icon} alt="button icon" />
        </div>
      );
    } else {
      return (
        <div
          style={{ cursor: "pointer", color: button.color }}
          onClick={button.onClick}
        >
          {button.text}
        </div>
      );
    }
  } else {
    return null;
  }
}
